import { lazy, Suspense } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { AppShell } from "./components/app-shell";
import { Loading } from "./components/ui";
import { useSession } from "./context/session";
import { AnalyticsPage } from "./pages/analytics-page";
import { ApiPage } from "./pages/api-page";
import { LifecyclePage } from "./pages/lifecycle-page";
import { LinksPage } from "./pages/links-page";
import { PoolPage } from "./pages/pool-page";
import {
  LoginPage,
  MaintenancePage,
  RegisterPage,
  UnavailablePage,
} from "./pages/public-pages";
import { HomePage } from "./pages/home-page";
import { ReviewPage } from "./pages/review-page";
import { SettingsPage } from "./pages/settings-page";
import { UsersPage } from "./pages/users-page";
import { MailPage } from "./pages/mail-page";
import { MailAdminPage } from "./pages/mail-admin-page";
import { MailDomainsPage } from "./pages/mail-domains-page";

const GeoStatsPage = lazy(() => import("./pages/geo-stats-page").then((module) => ({ default: module.GeoStatsPage })));

function Protected() {
  const { user, config, loading } = useSession();
  if (loading) return <main className="public-shell public-shell--center"><Loading label="验证会话" /></main>;
  if (!user) return <Navigate to="/login" replace />;
  if (config?.maintenanceMode && user.role === "user") return <Navigate to="/maintenance" replace />;
  return <Outlet />;
}

function AdminOnly() {
  const { user } = useSession();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "user") return <Navigate to="/console/links" replace />;
  return <Outlet />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/maintenance" element={<MaintenancePage />} />
      <Route path="/unavailable" element={<UnavailablePage />} />
      <Route element={<Protected />}>
        <Route path="/console" element={<AppShell />}>
          <Route index element={<Navigate to="links" replace />} />
          <Route path="links" element={<LinksPage />} />
          <Route path="mail" element={<MailPage />} />
          <Route element={<AdminOnly />}>
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="geography" element={<Suspense fallback={<Loading label="载入世界地图" />}><GeoStatsPage /></Suspense>} />
            <Route path="api" element={<ApiPage />} />
            <Route path="review" element={<ReviewPage />} />
            <Route path="pool" element={<PoolPage />} />
            <Route path="lifecycle" element={<LifecyclePage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="mail-admin" element={<MailAdminPage />} />
            <Route path="mail-domains" element={<MailDomainsPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
